import React, { useState } from "react";
import "../styles/Transposhelppanel.css";
import { useGame } from "../GameContext";

const Helppanel: React.FC = () => {
  console.log("HelpPanel render");
  const { isHelpPanelOpen, setHelpPanelOpen } = useGame();
  const [showhelpPivots, setShowhelpPivots] = useState<string>("pivotTask");

  if (!isHelpPanelOpen) {
    return null;
  }

  return (
    <div className="transpos-helpPanel" id="transpos-helpPanel">
      <img
        src="/img/close.svg"
        id="transpos-closeButton"
        alt="Закрыть"
        className="transpos-closeButton"
        onClick={() => setHelpPanelOpen(false)}
      />
      <div className="transpos-helpPivots">
        <div
          className="transpos-selectPivots"
          id={showhelpPivots === "pivotTask" ? "transpos-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotTask")}
        >
          Задача
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="transpos-commandsCards">
          <div className="transpos-helpCard">
            <div className="transpos-cardCaption">Суть игры</div>
            <div>
              {/* изменить с этого места */}
              Прочитать зашифрованный текст и отгадать загаданное слово.
              {/* до этого */}
            </div>
          </div>
          <div className="transpos-helpCard">
            <div className="transpos-cardCaption">Правила игры</div>
            <div>
              {/* изменить с этого места */}
              {" "}
              <>
                В каждом слове слоги переставлены <b>в обратном порядке</b>.
                <br />
                Нужно мысленно вернуть слоги на места и прочитать текст.
                <br />
                <br />
                Прочитай получившийся текст-загадку и впиши правильный ответ в
                поле.
                <br />
              </>
              {/* до этого */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Helppanel;
